import { CollapseComponent } from '@opten/collapse';
import { factory } from '@opten/compiler/factory';
import { scrollToOffset } from '@opten/scroll/scroll-to-offset';
import { ChartComponent } from './components/chart';
import { ContainInnerComponent } from './components/contain-inner';
import { CookieBannerComponent } from './components/cookie-banner';
import { DoubleScrollComponent } from './components/double-scroll';
import { FitTextComponent } from './components/fit-text';
import { HeaderComponent } from './components/header';
import { InverterComponent } from './components/inverter';
import { MediaTransitionComponent } from './components/media-transition';
import { ModalComponent } from './components/modal';
import { PageRenderHelper } from './components/page-render-helper';
import { IFramePlayerComponent } from './components/player';
import { SectionScrollComponent } from './components/section-scroll';
import { SectionScrollProgressComponent } from './components/section-scroll-progress';
import { SectionSliderComponent } from './components/section-slider';
import { TabsComponent } from './components/tabs';
import { TransformFullToHalfComponent } from './components/transform-full-half';
import { GallerySliderComponent } from './components/gallery-slider';

declare const ScrollMagic: any;
export const ScrollMagicController = new ScrollMagic.Controller();
const modal = document.querySelector('.js-modal-inner');
export const ScrollMagicModalController = new ScrollMagic.Controller({
	container: modal || window
});
export const ScrollMagicDesktopModalController = new ScrollMagic.Controller({
	container: modal || window
});
export const ScrollMagicDesktopController = new ScrollMagic.Controller();
[ScrollMagicDesktopModalController, ScrollMagicDesktopController].forEach(
	controller =>
		controller.scrollPos(() => {
			if (window.innerWidth >= 768) {
				return (
					controller.info().container.scrollY ||
					controller.info().container.scrollTop
				);
			} else {
				return 0;
			}
		})
);

const initialize = factory([
	CollapseComponent,
	InverterComponent,
	CookieBannerComponent,
	HeaderComponent,
	SectionSliderComponent,
	SectionScrollComponent,
	SectionScrollProgressComponent,
	TabsComponent,
	ModalComponent,
	MediaTransitionComponent,
	ChartComponent,
	TransformFullToHalfComponent,
	IFramePlayerComponent,
	GallerySliderComponent,
	DoubleScrollComponent,
	FitTextComponent,
	ContainInnerComponent
]);

initialize(document.body);

PageRenderHelper.onPageChange.subscribe(newContent => {
	initialize(newContent);
});

if (window.location.hash) {
	const elem = document.getElementById(window.location.hash.substring(1));
	if (elem) {
		const wrapper =
			(elem.closest('.js-modal-inner') as HTMLElement) || window;
		scrollToOffset(
			wrapper instanceof HTMLElement
				? elem.getBoundingClientRect().top -
						wrapper.getBoundingClientRect().top
				: elem.getBoundingClientRect().top,
			undefined,
			undefined,
			undefined,
			wrapper
		);
	}
}
